import { Language } from "@/data/model/Enums";

import { clientLanguage } from "@/shared/localization/language";

export let translations: {
    addToCartPopover: {
        price: string;
        optional: string;
        optionSing: string;
        optionPlur: string;
        chooseExact: string;
        chooseMin: string;
        chooseUpTo: string;
        chooseBetween: string;
        upToTotalItems: string;
        chooseOption: string;
        loadingOptions: string;
        failedLoadingOptions: string;
        adding: string;
    };
    allocation: {
        allocationFailed: string;
    };
    auth: {
        sessionExpiredTitle: string;
        sessionExpiredMessage: string;
        sessionExpiredBecauseAccessRightsChangedMessage: string;
    };
    bill: {
        clearSelection: string;
        exclTip: string;
        fullyPaidItems: string;
        noOrderYet: string;
        paid: string;
        selectAll: string;
    };
    billSection: {
        loadingData: string;
        noPaymentServiceConfigured: string;
        processingPaymentDevicePayment: string;
    };
    cancellation: {
        amount: string;
        cancellation: string;
        cancellationFailed: string;
        cancellationNotAllowedForPayment: string;
        canStockBeReused: string;
        cancellationSuccessful: string;
        confirmMessage: string;
        confirmTitle: string;
        failedLoading: string;
        loading: string;
        notNow: string;
        notPaid: string;
        offlineMode: string;
        paid: string;
        payment: string;
        paymentMethod: string;
        positionSectionTitle: string;
        positionsText: string;
        reason: string;
        quantity: string;
        status: string;
        submitBtn: string;
        title: string;
        totalIncTip: string;
        user: string;
        wholeOrderText: string;
        singleCancellationFailed: string;
        multipleCancellationsFailed: string;
        multiplePdPaymentCancellationsNotSupported: string;
        twintOnlineRefundNotSupported: string;
        wholeOrderDesc: string;
    };
    cancellationReason: {
        reason: string;
    };
    cart: {
        addComment: string;
        failedToAdd: string;
        failedToChange: string;
        failedToRemove: string;
        haveItemsInCart: string;
        noItems: string;
        notAbleToPrepareForCheckout: string;
        order: string;
        paymentBlockingCart: string;
        changingTotalWillRemoveAppliedDiscountsMessage: string;
        removeDiscounts: string;
    };
    cartItemsList: {
        cart: string;
    };
    changeAllocationDetailsModal: {
        endUsersCouldNotBeRemoved: string;
        rename: string;
        removeEndUsers: string;
        resetTable: string;
        resetTableText: string;
        transferBill: string;
        transferSelectedBillItems: string;
        print: string;
    };
    currency: {
        chf: string;
    };
    discounts: {
        removeSingleItemDiscountPrompt: string;
        removeAllItemDiscountsPrompt: string;
    };
    enums: {
        cancellationMode: {
            Amount: string;
            Positions: string;
            WholeOrder: string;
        };
        cancellationReason: {
            IncorrectIncompleteItemInformation: string;
            OrderedIncorrectlyEndUser: string;
            OrderedIncorrectlyStaffMember: string;
            EndUserChangedMind: string;
            ItemNotAvailable: string;
            PriceWrong: string;
            BusinessClosedAtFulfilmentTime: string;
            LossBreakageStaffMember: string;
            LateFulfilment: string;
            BadQualityPresentation: string;
            LossBreakageEndUser: string;
            CustomerDidNotPayWalkout: string;
            Other: string;
        };
        connectionState: {
            Disconnected: string;
            Connecting: string;
            Connected: string;
            Disconnecting: string;
            Reconnecting: string;
        };
        fulfillmentTimeMode: {
            DeliveryTime: string;
            None: string;
            PickupTime: string;
            Time: string;
        };
    };
    general: {
        accept: string;
        add: string;
        addingButtonPlaceholder: string;
        anonymousUser: string;
        back: string;
        cancel: string;
        close: string;
        confirm: string;
        continue: string;
        date: string;
        display: string;
        edit: string;
        end: string;
        error: string;
        failedLoadingData: string;
        loading: string;
        no: string;
        of: string;
        ok: string;
        operationFailed: string;
        pleaseSelect: string;
        remove: string;
        reset: string;
        save: string;
        start: string;
        time: string;
        today: string;
        unknown: string;
        understood: string;
        yes: string;
    };
    messages: {
        deviceNotFoundPleaseRefresh: string;
        unauthorizedPleaseRefresh: string;
    };
    linkOffer: {
        childLocation: string;
        offers: string;
        linkedOffers: string;
        linkedOffer: string;
        noLinkedOffers: string;
        noAvailableOptions: string;
    }
    offerSection: {
        loadingData: string;
        noActiveOffer: string;
        noOrderServiceConfigured: string;
    };
    order: {
        itemsSelected: string;
    };
    orderAndPayView: {
        failedLoadingOffer: string;
        failedToAllocateToTable: string;
        failedLoadingBill: string;
    };
    openBills: {
        bill: string;
        due: string;
        failedLoadingBills: string;
        loadingData: string;
        noOpenBills: string;
        occupancy: string;
        open: string;
        operator: string;
        ordersForNow: string;
        ordersForNowOrLater: string;
        room: string;
        since: string;
        table: string;
        title: string;
    };
    pay: {
        approximately: string;
        btnOrderAgain: string;
        cartChangedAndPleaseWaitMessage: string;
        cartChangedMessage: string;
        cartChangedTitle: string;
        consumption: string;
        discount: string;
        discountVoucherCode: string;
        enterTip: string;
        failedBillInvalidSelection: string;
        failedBillPaymentInProgress: string;
        failedEmailNotConfirmed: string;
        failedIdentityNotSignedUp: string;
        failedOutOfStock: string;
        failedPaymentInProgress: string;
        failedPaymentInvalidCard: string;
        failedPaymentUnknownReason: string;
        fulfillmentSlotTimedOut: string;
        isEmailCorrectQuestion: string;
        newFulfillmentSlotAvailable: string;
        noActivePaymentService: string;
        noFulfillmentSlotAvailable: string;
        noFulfillmentSlotAvailableV2: string;
        paymentInProgressWarning: string;
        paymentRecentlyDoneWarning: string;
        payNow: string;
        pleaseEnterEndUsersEmail: string;
        received: string;
        scheduledTime: string;
        tip: string;
        twintReturnWarning: string;
        walleePaymentNotAvailable: string;
    };
    print: {
        orderReceiptPrinted: string;
        failedPrintReceipt: string;
    };
    profile: {
        email: string;
        emailConfirmed: string;
        emailUnconfirmed: string;
    };
    qrScanner: {
        pointCameraQr: string;
        scanQr: string;
    };
    receipt: {
        failedPrintReceipt: string;
        failedSendReceipt: string;
        noProductionSiteEnabledForRoom: string;
        printReceipt: string;
        sendReceipt: string;
        sentReceiptTo: string;
    };
    renameBillModal: {
        billNameLabel: string;
        billNamePlaceholder: string;
    };
    report: {
        paymentMethodsReport: string;
    };
    roomPlan: {
        failedLoadingTables: string;
        loadingTables: string;
        room: string;
        selectTableToTransferBill: string;
    };
    tableAllocationContextMenu: {
        adjustEndUsersCountFailed: string;
    };
};

const setEnglish = () => {
    translations = {
        addToCartPopover: {
            price: "Price",
            optional: "Optional",
            optionSing: "option",
            optionPlur: "options",
            chooseExact: "Select {0} {1}",
            chooseMin: "Select at least {0} {1}",
            chooseUpTo: "Optional. Select up to {0} {1}",
            chooseBetween: "Select {0} - {1} options",
            upToTotalItems: "In total up to {0} items",
            chooseOption: "Select your options",
            loadingOptions: "Options are being loaded...",
            failedLoadingOptions: "Options could not be loaded.",
            adding: "...",
        },
        allocation: {
            allocationFailed: "Unfortunately, check-in failed. Please reload the page and try again.",
        },
        auth: {
            sessionExpiredTitle: "Session expired",
            sessionExpiredMessage: "Your session expired. Please log in again.",
            sessionExpiredBecauseAccessRightsChangedMessage: "You have been logged out due to a change in access rights. Please log in again.",
        },
        bill: {
            clearSelection: "Clear selection",
            exclTip: "excl. tip",
            fullyPaidItems: "Fully Paid Items",
            noOrderYet: "Everything is paid, thank you!",
            paid: "Paid",
            selectAll: "Select everything",
        },
        billSection: {
            loadingData: "Loading data...",
            noPaymentServiceConfigured: "No Payment Service configured",
            processingPaymentDevicePayment: "Payment in progress...",
        },
        cancellation: {
            amount: "Amount",
            cancellation: "Cancellation",
            cancellationFailed: "Order could not be cancelled.",
            cancellationNotAllowedForPayment: "Cancellation is not allowed for this payment",
            canStockBeReused: "Can the stock be reused?",
            cancellationSuccessful: "Cancellation successful",
            confirmMessage: "{{amt}} CHF - do you really want to cancel this? This cannot be reversed.",
            confirmTitle: "Perform cancellation?",
            failedLoading: "Order could not be loaded.",
            loading: "Order is being loaded...",
            notNow: "Not now",
            notPaid: "Not paid",
            offlineMode: "Offline refund",
            paid: "Paid",
            payment: "Payment",
            paymentMethod: "Payment method",
            positionSectionTitle: "Which units of <b>{{itemName}}</b> shall be cancelled?",
            positionsText: "Select the items to be cancelled:",
            reason: "Reason",
            quantity: "Quantity",
            status: "Status",
            submitBtn: "Yes, cancel",
            title: "Cancellation",
            totalIncTip: "Total incl. tip",
            user: "User",
            wholeOrderText: "The entire order will be cancelled.",
            singleCancellationFailed: "Cancellation failed. Please try again.",
            multipleCancellationsFailed: "At least one cancellation failed. Some payments may not have been refunded. Please try again.",
            multiplePdPaymentCancellationsNotSupported: "This cancellation includes multiple payments via a payment device. Please limit it to a maximum of one payment device payment.",
            twintOnlineRefundNotSupported: "Twint payments made on payment devices cannot be refunded.",
            wholeOrderDesc: "The entire order will be cancelled.",
        },
        cancellationReason: {
            reason: "Reason",
        },
        cart: {
            addComment: "Add special requests",
            failedToAdd: "Item could not be added.",
            failedToChange: "Item could not be modified.",
            failedToRemove: "Item could not be removed.",
            haveItemsInCart: "You have items in your {0} cart. If you continue, your cart will be deleted.",
            noItems: "No items have been added to the cart yet.",
            notAbleToPrepareForCheckout: "Cart could not be prepared for payment.",
            order: "Order",
            paymentBlockingCart: "The cart cannot be adjusted while a payment is in progress.",
            changingTotalWillRemoveAppliedDiscountsMessage: "Changing the total will remove all applied discounts. You’ll need to reapply them.",
            removeDiscounts: "Remove Discounts",
        },
        cartItemsList: {
            cart: "Cart",
        },
        changeAllocationDetailsModal: {
            endUsersCouldNotBeRemoved: "End users could not be removed",
            rename: "Rename",
            removeEndUsers: "Remove end users",
            resetTable: "Check Out Users",
            resetTableText: "Should all {0} users get checked out of {1}? This is not revocable.",
            transferBill: "Transfer",
            transferSelectedBillItems: "Transfer {0} items",
            print: "Print",
        },
        currency: {
            chf: "CHF",
        },
        discounts: {
            removeSingleItemDiscountPrompt: "Remove discount?",
            removeAllItemDiscountsPrompt: "This discount applies to several items and can only be removed as a whole. Remove?",
        },
        enums: {
            cancellationMode: {
                Amount: "Custom amount",
                Positions: "Individual items",
                WholeOrder: "Entire order",
            },
            cancellationReason: {
                IncorrectIncompleteItemInformation: "Incorrect / incomplete item information",
                OrderedIncorrectlyEndUser: "Ordered incorrectly (end user)",
                OrderedIncorrectlyStaffMember: "Ordered incorrectly (staff member)",
                EndUserChangedMind: "End user changed his/her mind",
                ItemNotAvailable: "Item not available",
                PriceWrong: "Price wrong",
                BusinessClosedAtFulfilmentTime: "Business closed at fulfilment time",
                LossBreakageStaffMember: "Loss / Breakage (staff member)",
                LateFulfilment: "Late fulfilment",
                BadQualityPresentation: "Bad quality / presentation",
                LossBreakageEndUser: "Loss / Breakage (end user)",
                CustomerDidNotPayWalkout: "Customer did not pay (walkout)",
                Other: "Other",
            },
            connectionState: {
                Connected: "Connected!",
                Connecting: "Trying to connect...",
                Disconnected: "Disconnected!",
                Disconnecting: "Disconnecting...",
                Reconnecting: "Trying to reconnect...",
            },
            fulfillmentTimeMode: {
                DeliveryTime: "Delivery Time",
                None: "None",
                PickupTime: "Pickup Time",
                Time: "Time (type not specified)",
            },
        },
        general: {
            accept: "Accept",
            add: "Add",
            addingButtonPlaceholder: "...",
            anonymousUser: "Anonymous end user",
            back: "Back",
            cancel: "Cancel",
            close: "Close",
            continue: "Continue",
            confirm: "Confirm",
            date: "Date",
            display: "Display",
            edit: "Edit",
            end: "End",
            error: "Error",
            failedLoadingData: "Data could not be loaded.",
            loading: "Loading...",
            no: "No",
            of: "out of",
            ok: "Ok",
            operationFailed: "The operation could not be performed.",
            pleaseSelect: "Please select",
            remove: "Remove",
            reset: "Reset",
            save: "Save",
            start: "Start",
            time: "Time",
            today: "Today",
            unknown: "Unknown",
            understood: "Understood",
            yes: "Yes",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Device not found. The page will reload, please sign in again.",
            unauthorizedPleaseRefresh: "Your session has expired. The page will reload, please try again.",
        },
        linkOffer: {
            childLocation: "Child location",
            offers: "Offers",
            linkedOffers: "Linked offers",
            linkedOffer: "Linked offer",
            noLinkedOffers: "No linked offers",
            noAvailableOptions: "No available options",
        },
        offerSection: {
            loadingData: "Loading data...",
            noActiveOffer: "No active offer",
            noOrderServiceConfigured: "No Order Service configured",
        },
        order: {
            itemsSelected: "{0} item(s) selected",
        },
        orderAndPayView: {
            failedLoadingOffer: "Failed to load offer.",
            failedToAllocateToTable: "Check-in failed",
            failedLoadingBill: "Failed to load bill",
        },
        openBills: {
            bill: "Bill",
            due: "Due",
            failedLoadingBills: "Failed to load open bills.<br>Please try again later.",
            loadingData: "Loading data...",
            noOpenBills: "No open bills",
            occupancy: "Occupancy",
            open: "Open",
            operator: "Operator",
            ordersForNow: "Orders for: Now",
            ordersForNowOrLater: "Orders for: Now or later",
            room: "Room",
            since: "Since",
            table: "Table",
            title: "Open bills",
        },
        pay: {
            approximately: "approx.",
            btnOrderAgain: "Order Additionally",
            cartChangedAndPleaseWaitMessage: "Due to lack of availability or a price change at least one item will be deleted from your cart shortly. Please wait a few seconds for the update.",
            cartChangedMessage: "Due to lack of availability or a price change at least one item will be deleted from your cart.",
            cartChangedTitle: "New total price",
            consumption: "Consumption",
            discount: "Discount",
            discountVoucherCode: "Discount / Voucher code",
            enterTip: "Enter tip (optional)",
            failedBillInvalidSelection: "At least one selected item has already been paid for or canceled. Please check your selection.",
            failedBillPaymentInProgress: "Another payment is in progress, the affected items have been deselected. Make a payment without these items or try again in a few minutes.",
            failedEmailNotConfirmed: 'Please sign up: Circle at the top right > "Sign Up" > follow instructions. Already signed up? Circle at the top right > "Profile" > “Resend Confirmation E-Mail" > Open and confirm e-mail',
            failedIdentityNotSignedUp: 'Please sign up: Circle at the top right > "Sign Up"',
            failedOutOfStock: "Desired quantity is unfortunately not available, please adjust the cart:<br />{0}",
            failedPaymentInProgress: "Another payment is in progress. Please wait",
            failedPaymentInvalidCard: "Unfortunately, this brand is not accepted or the card has been rejected by your bank.",
            failedPaymentUnknownReason: "Payment cancelled. Please try again.",
            fulfillmentSlotTimedOut: "The selected time has timed out. Please select a new time.",
            isEmailCorrectQuestion: "Is this correct: {0}?",
            newFulfillmentSlotAvailable: "New {0} {1} due to the selected items or time slot expiry.",
            noActivePaymentService: "No active Payment Service.",
            noFulfillmentSlotAvailable: "Sorry, at least one selected item is not available, please try again later or change your selection.",
            noFulfillmentSlotAvailableV2: "No availability. {0} might add availability in the future, please check back here soon.",
            paymentInProgressWarning: "Attention, other payment in progress. If you have authorised it with the payment provider, the order will be triggered shortly - please Cancel. If the payment failed or you want to order more, select Order Additionally.",
            paymentRecentlyDoneWarning: 'Attention, potential double order. You have recently successfully ordered, see "Orders" in the side menu (top right circle). Place an additional order?',
            payNow: "Pay",
            pleaseEnterEndUsersEmail: "Please enter the end user's email.",
            received: "Received",
            scheduledTime: "scheduled time",
            tip: "Tip",
            twintReturnWarning: "Please return to the browser after payment to speed up the order and receive important information.",
            walleePaymentNotAvailable: "Sorry, this payment method is currently not available. Try a different one or try later again.",
        },
        print: {
            failedPrintReceipt: "Print job failed",
            orderReceiptPrinted: "Print job sent",
        },
        profile: {
            email: "Email",
            emailConfirmed: "Confirmed",
            emailUnconfirmed: "Not confirmed",
        },
        qrScanner: {
            pointCameraQr: "Point your camera at the QR code",
            scanQr: "Scan QR Code",
        },
        receipt: {
            failedPrintReceipt: "Print job failed",
            failedSendReceipt: "Failed to send receipt. Please try again.",
            noProductionSiteEnabledForRoom: "No activated receipt printer is assigned to this table / room.",
            printReceipt: "Print Receipt",
            sendReceipt: "Send Receipt",
            sentReceiptTo: "Receipt was sent to {0}.",
        },
        renameBillModal: {
            billNameLabel: "Bill name",
            billNamePlaceholder: "New bill name...",
        },
        report: {
            paymentMethodsReport: "Payment methods report",
        },
        roomPlan: {
            failedLoadingTables: "Failed to load tables.<br />Please try again later.",
            loadingTables: "Loading tables...",
            room: "Room",
            selectTableToTransferBill: "Select destination",
        },
        tableAllocationContextMenu: {
            adjustEndUsersCountFailed: "Unable to adjust the number of end users.",
        },
    };
};

const setGerman = () => {
    translations = {
        addToCartPopover: {
            price: "Preis",
            optional: "Optional",
            optionSing: "Option",
            optionPlur: "Optionen",
            chooseExact: "Wähle {0} {1} aus",
            chooseMin: "Wähle mind. {0} {1} aus",
            chooseUpTo: "Optional. Wähle bis zu {0} {1} aus",
            chooseBetween: "Wähle {0} - {1} Optionen aus",
            upToTotalItems: "Insg. bis zu {0} Artikel",
            chooseOption: "Wähle deine Optionen",
            loadingOptions: "Optionen werden geladen...",
            failedLoadingOptions: "Optionen konnten nicht geladen werden.",
            adding: "...",
        },
        allocation: {
            allocationFailed: "Leider ist das Einchecken fehlgeschlagen. Bitte lade die Seite neu und versuche es nochmals.",
        },
        auth: {
            sessionExpiredTitle: "Sitzung abgelaufen",
            sessionExpiredMessage: "Ihre Sitzung ist abgelaufen. Bitte loggen Sie sich erneut ein.",
            sessionExpiredBecauseAccessRightsChangedMessage: "Sie wurden aufgrund einer Änderung der Zugriffsrechte ausgeloggt. Bitte loggen Sie sich erneut ein.",
        },
        bill: {
            clearSelection: "Auswahl aufheben",
            exclTip: "exkl. Trinkgeld",
            fullyPaidItems: "Vollständig Bezahlte Artikel",
            noOrderYet: "Alles ist bezahlt, danke!",
            paid: "Gezahlt",
            selectAll: "Alles auswählen",
        },
        billSection: {
            loadingData: "Daten laden...",
            noPaymentServiceConfigured: "Kein Zahlungsdienst konfiguriert",
            processingPaymentDevicePayment: "Zahlung im Gange...",
        },
        cancellation: {
            amount: "Betrag",
            cancellation: "Stornierung",
            cancellationFailed: "Bestellung konnte nicht storniert werden.",
            cancellationNotAllowedForPayment: "Stornierung ist für diese Zahlung nicht erlaubt.",
            canStockBeReused: "Kann der Bestand wiederverwendet werden?",
            cancellationSuccessful: "Stornierung erfolgreich",
            confirmMessage: "{{amt}} CHF wirklich stornieren? Dies kann nicht rückgängig gemacht werden.",
            confirmTitle: "Stornierung ausführen?",
            failedLoading: "Bestellung konnte nicht geladen werden.",
            loading: "Bestellung wird geladen...",
            notNow: "Nicht jetzt",
            notPaid: "Nicht bezahlt",
            offlineMode: "Offline Rückerstattung",
            paid: "Bezahlt",
            payment: "Zahlung",
            paymentMethod: "Zahlungsmittel",
            positionSectionTitle: "Welche Einheiten von <b>{{itemName}}</b> sollen storniert werden?",
            positionsText: "Die zu stornierenden Positionen wählen:",
            reason: "Grund",
            quantity: "Anzahl",
            status: "Status",
            submitBtn: "Ja, stornieren",
            title: "Stornierung",
            totalIncTip: "Total inkl. Trinkgeld",
            user: "Nutzer",
            wholeOrderText: "Die gesamte Bestellung wird storniert werden.",
            singleCancellationFailed: "Stornierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
            multipleCancellationsFailed: "Mindestens eine Stornierung ist fehlgeschlagen. Gewisse Zahlungen wurden möglicherweise nicht erstattet. Bitte versuchen Sie es erneut.",
            multiplePdPaymentCancellationsNotSupported: "Diese Stornierung umfasst mehrere Zahlungen über ein Zahlungsgerät. Bitte beschränken Sie sie auf maximal eine Zahlungsgerät-Zahlung.",
            twintOnlineRefundNotSupported: "Twint-Zahlungen, die auf Zahlungsgeräten getätigt wurden, können nicht zurückerstattet werden.",
            wholeOrderDesc: "Die gesamte Bestellung wird storniert werden.",
        },
        cancellationReason: {
            reason: "Grund",
        },
        cart: {
            addComment: "Sonderwünsche hinzufügen",
            failedToAdd: "Artikel konnte nicht hinzugefügt werden.",
            failedToChange: "Artikel konnte nicht modifiziert werden.",
            failedToRemove: "Artikel konnte nicht entfernt werden.",
            haveItemsInCart: "Du hast Artikel in deinem {0} Warenkorb. Wenn du fortfährst, wird dein Warenkorb gelöscht.",
            noItems: "Dem Warenkorb wurden noch keine Artikel hinzugefügt.",
            notAbleToPrepareForCheckout: "Warenkorb konnte nicht für die Zahlung vorbereitet werden.",
            order: "Bestellen",
            paymentBlockingCart: "Der Warenkorb kann nicht angepasst werden während eine Zahlung in Bearbeitung ist.",
            changingTotalWillRemoveAppliedDiscountsMessage: "Das Verändern des Gesamttotals entfernt alle angewendeten Rabatte. Du musst sie danach erneut anwenden.",
            removeDiscounts: "Rabatte Entfernen",
        },
        cartItemsList: {
            cart: "Warenkorb",
        },
        changeAllocationDetailsModal: {
            endUsersCouldNotBeRemoved: "Endnutzer konnten nicht entfernt werden",
            rename: "Umbenennen",
            removeEndUsers: "Endnutzer entfernen",
            resetTable: "Nutzer Auschecken",
            resetTableText: "Sollen alle {0} Nutzer von {1} ausgecheckt werden? Dies ist nicht widerrufbar.",
            transferBill: "Übertragen",
            transferSelectedBillItems: "{0} Artikel übertragen",
            print: "Drucken",
        },
        currency: {
            chf: "CHF",
        },
        discounts: {
            removeSingleItemDiscountPrompt: "Rabatt entfernen?",
            removeAllItemDiscountsPrompt: "Dieser Rabatt gilt für mehrere Artikel und kann nur als Ganzes entfernt werden. Entfernen?",
        },
        enums: {
            cancellationMode: {
                Amount: "Manueller Betrag",
                Positions: "Einzelpositionen",
                WholeOrder: "Gesamte Bestellung",
            },
            cancellationReason: {
                IncorrectIncompleteItemInformation: "Falsche / unvollständige Artikelinformationen",
                OrderedIncorrectlyEndUser: "Falsch bestellt (Endnutzer)",
                OrderedIncorrectlyStaffMember: "Falsch bestellt (Mitarbeiter)",
                EndUserChangedMind: "Endnutzer hat seine Meinung geändert",
                ItemNotAvailable: "Artikel nicht verfügbar",
                PriceWrong: "Preis falsch",
                BusinessClosedAtFulfilmentTime: "Geschäft zur Erfüllungszeit geschlossen",
                LossBreakageStaffMember: "Bruch / Verlust (Mitarbeiter)",
                LateFulfilment: "Verspätete Erfüllung",
                BadQualityPresentation: "Schlechte Qualität / Präsentation",
                LossBreakageEndUser: "Bruch / Verlust (Endnutzer)",
                CustomerDidNotPayWalkout: "Kunde hat nicht bezahlt (Zechprellerei)",
                Other: "Anderer",
            },
            connectionState: {
                Connected: "Verbunden!",
                Connecting: "Verbindung wird aufgebaut...",
                Disconnected: "Verbindung getrennt!",
                Disconnecting: "Verbindung wird beendet...",
                Reconnecting: "Verbindung wird aufgebaut...",
            },
            fulfillmentTimeMode: {
                DeliveryTime: "Lieferzeit",
                None: "Nein",
                PickupTime: "Abholzeit",
                Time: "Zeit (Typ nicht spezifiziert)",
            },
        },
        general: {
            accept: "Akzeptieren",
            add: "Hinzufügen",
            addingButtonPlaceholder: "...",
            anonymousUser: "Anonymer Endnutzer",
            back: "Zurück",
            cancel: "Abbrechen",
            close: "Schliessen",
            continue: "Weiter",
            confirm: "Bestätigen",
            date: "Datum",
            display: "Anzeigen",
            edit: "Bearbeiten",
            end: "Ende",
            error: "Fehler",
            failedLoadingData: "Daten konnten nicht geladen werden.",
            loading: "Wird geladen...",
            no: "Nein",
            of: "von",
            ok: "Ok",
            operationFailed: "Der Vorgang konnte nicht ausgeführt werden.",
            pleaseSelect: "Bitte auswählen",
            remove: "Löschen",
            reset: "Zurücksetzen",
            save: "Speichern",
            start: "Beginn",
            time: "Uhrzeit",
            today: "Heute",
            unknown: "Unbekannt",
            understood: "Verstanden",
            yes: "Ja",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Gerät nicht gefunden. Die Seite wird neu geladen, bitte loggen Sie sich erneut ein.",
            unauthorizedPleaseRefresh: "Deine Sitzung ist abgelaufen. Die Seite wird neu geladen, bitte versuche es nochmals.",
        },
        linkOffer: {
            childLocation: "Untergeordneter Standort",
            offers: "Angebote",
            linkedOffers: "Verknüpfte Angebote",
            linkedOffer: "Verknüpfte Angebot",
            noLinkedOffers: "Keine verknüpften Angebote",
            noAvailableOptions: "Keine verfügbaren Optionen",
        },
        offerSection: {
            loadingData: "Daten laden...",
            noActiveOffer: "Kein aktives Angebot",
            noOrderServiceConfigured: "Kein Bestellservice konfiguriert",
        },
        order: {
            itemsSelected: "{0} Artikel ausgewählt",
        },
        orderAndPayView: {
            failedLoadingOffer: "Das Angebot konnte nicht geladen werden.",
            failedToAllocateToTable: "Einchecken fehlgeschlagen",
            failedLoadingBill: "Rechnung konnte nicht geladen werden",
        },
        openBills: {
            bill: "Rechnung",
            due: "Fällig",
            failedLoadingBills: "Offene Rechnungen konnten nicht geladen werden.<br>Bitte versuchen Sie es später erneut.",
            loadingData: "Daten laden...",
            noOpenBills: "Keine offenen Rechnungen",
            occupancy: "Belegung",
            open: "Offen",
            operator: "Bediener",
            ordersForNow: "Bestellungen für: Jetzt",
            ordersForNowOrLater: "Bestellungen für: Jetzt oder später",
            room: "Raum",
            since: "Seit",
            table: "Tisch",
            title: "Offene Rechnungen",
        },
        pay: {
            approximately: "ca.",
            btnOrderAgain: "Zusätzlich Bestellen",
            cartChangedAndPleaseWaitMessage: "Aufgrund von mangelnder Verfügbarkeit oder einer Preisänderung wird mindestens ein Artikel in Kürze aus deinem Warenkorb gelöscht werden. Bitte warte ein paar Sekunden auf die Aktualisierung.",
            cartChangedMessage: "Aufgrund von mangelnder Verfügbarkeit oder einer Preisänderung wird mindestens ein Artikel aus deinem Warenkorb gelöscht.",
            cartChangedTitle: "Neuer Gesamtpreis",
            consumption: "Konsumation",
            discount: "Rabatt",
            discountVoucherCode: "Rabatt- / Gutscheincode",
            enterTip: "Trinkgeld eingeben (optional)",
            failedBillInvalidSelection: "Mindestens ein ausgewählter Artikel ist bereits bezahlt oder storniert worden. Bitte überprüfe deine Auswahl.",
            failedBillPaymentInProgress: "Eine andere Zahlung ist im Gange, die betroffenen Artikel wurden abgewählt. Tätige eine Zahlung ohne diese Artikel oder versuche es in ein paar Minuten erneut.",
            failedEmailNotConfirmed: 'Bitte registriere dich: Kreis oben rechts > "Registrieren" > Anweisungen folgen. Bereits registriert? Kreis oben rechts > "Profil" > "Bestätigungs-E-Mail erneut senden" > E-Mail öffnen und bestätigen',
            failedIdentityNotSignedUp: 'Bitte registriere dich: Kreis oben rechts > "Registrieren"',
            failedOutOfStock: "Gewünschte Anzahl ist leider nicht verfügbar, bitte Warenkorb anpassen:<br />{0}",
            failedPaymentInProgress: "Eine andere Zahlung ist in Bearbeitung. Bitte warten",
            failedPaymentInvalidCard: "Leider wird diese Marke nicht akzeptiert oder die Karte wurde von deiner Bank abgelehnt.",
            failedPaymentUnknownReason: "Zahlung abgebrochen. Bitte versuche es erneut.",
            fulfillmentSlotTimedOut: "Die ausgewählte Zeit ist abgelaufen. Bitte wähle eine neue Zeit.",
            isEmailCorrectQuestion: "Ist dies richtig: {0}?",
            newFulfillmentSlotAvailable: "Neue {0} {1} aufgrund der gewählten Artikel oder Zeitüberschreitung.",
            noActivePaymentService: "Kein aktiver Zahlungsdienst.",
            noFulfillmentSlotAvailable: "Mindestens ein ausgewählter Artikel ist nicht verfügbar. Bitte versuche es später noch einmal oder ändere deine Auswahl.",
            noFulfillmentSlotAvailableV2: "Keine Verfügbarkeit. {0} wird möglicherweise in Zukunft Verfügbarkeit hinzufügen, bitte schaue bald wieder hier rein.",
            paymentInProgressWarning: "Achtung, andere Zahlung im Gange. Falls du diese beim Zahlungsanbieter genehmigt hast, wird die Bestellung in Kürze ausgelöst - bitte Abbrechen. Wenn die Zahlung fehlschlug oder du mehr bestellen willst, wähle Zusätzlich Bestellen.",
            paymentRecentlyDoneWarning: 'Achtung, potentielle Doppelbestellung. Du hast vor Kurzem erfolgreich bestellt, s. "Bestellungen" im Seitenmenü (Kreis rechts oben). Zusätzliche Bestellung tätigen?',
            payNow: "Zahlen",
            pleaseEnterEndUsersEmail: "Bitte geben Sie die E-Mail-Adresse des Endnutzers ein.",
            received: "Erhalten",
            scheduledTime: "geplante Uhrzeit",
            tip: "Trinkgeld",
            twintReturnWarning: "Bitte nach der Zahlung zum Browser zurückkehren, um die Bestellung zu beschleunigen und wichtige Informationen zu erhalten.",
            walleePaymentNotAvailable: "Entschuldigung, dieses Zahlungsmittel ist vorübergehend nicht verfügbar. Versuche es erneut oder ein anderes Zahlungsmittel.",
        },
        print: {
            failedPrintReceipt: "Druckauftrag fehlgeschlagen",
            orderReceiptPrinted: "Druckauftrag gesendet",
        },
        profile: {
            email: "E-Mail",
            emailConfirmed: "Bestätigt",
            emailUnconfirmed: "Nicht bestätigt",
        },
        qrScanner: {
            pointCameraQr: "Richte deine Kamera auf den QR-Code",
            scanQr: "QR-Code Scannen",
        },
        receipt: {
            failedPrintReceipt: "Receipt could not be printed.",
            failedSendReceipt: "Quittung konnte nicht verschickt werden. Bitte versuche es erneut.",
            noProductionSiteEnabledForRoom: "Diesem Tisch / Raum ist kein aktivierter Quittungsdrucker zugewiesen.",
            printReceipt: "Quittung Drucken",
            sendReceipt: "Quittung Schicken",
            sentReceiptTo: "Quittung wurde an {0} verschickt.",
        },
        renameBillModal: {
            billNameLabel: "Rechnungsname",
            billNamePlaceholder: "Neuer Rechnungsname...",
        },
        report: {
            paymentMethodsReport: "Zahlungsmittelbericht",
        },
        roomPlan: {
            failedLoadingTables: "Tische konnten nicht geladen werden.<br />Bitte versuchen Sie es später erneut.",
            loadingTables: "Tische werden geladen...",
            room: "Raum",
            selectTableToTransferBill: "Ziel auswählen",
        },
        tableAllocationContextMenu: {
            adjustEndUsersCountFailed: "Die Anzahl der Endnutzer konnte nicht angepasst werden.",
        },
    };
};

const setFrench = () => {
    translations = {
        addToCartPopover: {
            price: "Prezzo",
            optional: "Optionnel",
            optionSing: "option",
            optionPlur: "options",
            chooseExact: "Sélectionne {0} {1}",
            chooseMin: "Sélectionne au moins {0} {1}",
            chooseUpTo: "Optionnel. Sélectionne au maximum {0} {1}",
            chooseBetween: "Sélectionne {0} - {1} options",
            upToTotalItems: "Au total, jusqu'à {0} articles",
            chooseOption: "Sélectionne tes options",
            loadingOptions: "Les options sont chargées...",
            failedLoadingOptions: "Les options n'ont pas pu être chargées.",
            adding: "...",
        },
        allocation: {
            allocationFailed: "Malheureusement, l'enregistrement a échoué. Merci de recharger la page et d'essayer à nouveau.",
        },
        auth: {
            sessionExpiredTitle: "Session expiré",
            sessionExpiredMessage: "Votre session a expiré. Veuillez vous reconnecter.",
            sessionExpiredBecauseAccessRightsChangedMessage: "Vous avez été déconnecté en raison d'une modification des droits d'accès. Veuillez vous reconnecter.",
        },
        bill: {
            clearSelection: "Annuler la sélection",
            exclTip: "excl. pourboire",
            fullyPaidItems: "Articles Payés Intégralement",
            noOrderYet: "Tout est payé, merci!",
            paid: "Payé",
            selectAll: "Tout sélectionner",
        },
        billSection: {
            loadingData: "Chargement des données...",
            noPaymentServiceConfigured: "Pas de service de paiement configuré",
            processingPaymentDevicePayment: "Paiement en cours...",
        },
        cancellation: {
            amount: "Montant",
            cancellation: "Annulation",
            cancellationFailed: "La commande n'a pas pu être annulée.",
            cancellationNotAllowedForPayment: "L’annulation n’est pas autorisée pour ce paiement.",
            canStockBeReused: "Le stock peut-il être réutilisé?",
            cancellationSuccessful: "Annulation réussie",
            confirmMessage: "{{amt}} CHF vraiment annuler ? Cela ne peut pas être annulé.",
            confirmTitle: "Effectuer l'annulation ?",
            failedLoading: "La commande n'a pas pu être chargée.",
            loading: "Commande en cours de chargement...",
            notNow: "Pas maintenant",
            notPaid: "Non payé",
            offlineMode: "Remboursement hors ligne",
            paid: "Payé",
            payment: "Paiement",
            paymentMethod: "Moyen de paiement",
            positionSectionTitle: "Quelles unités de <b>{{itemName}}</b> doivent être annulées ?",
            positionsText: "Sélectionner les postes à annuler :",
            reason: "Raison",
            quantity: "Quantité",
            status: "Statut",
            submitBtn: "Oui, annuler",
            title: "Annulation",
            totalIncTip: "Total (y compris le pourboire)",
            user: "Utilisateur",
            wholeOrderText: "La commande entière sera annulée.",
            singleCancellationFailed: "L'annulation a échoué. Veuillez réessayer.",
            multipleCancellationsFailed: "Au moins une annulation a échoué. Certains paiements n’ont peut-être pas été remboursés. Veuillez réessayer.",
            multiplePdPaymentCancellationsNotSupported: "Cette annulation comprend plusieurs paiements via un appareil de paiement. Veuillez la limiter à un seul paiement via appareil de paiement.",
            twintOnlineRefundNotSupported: "Les paiements Twint effectués sur des appareils de paiement ne peuvent pas être remboursés.",
            wholeOrderDesc: "La commande entière sera annulée.",
        },
        cancellationReason: {
            reason: "Raison",
        },
        cart: {
            addComment: "Ajouter des demandes spéciales",
            failedToAdd: "L'article n'a pas pu être ajouté.",
            failedToChange: "L'article n'a pas pu être modifié.",
            failedToRemove: "L'article n'a pas pu être supprimé.",
            haveItemsInCart: "Tu as des articles dans ton panier {0}. Si tu continues, ton panier sera supprimé.",
            noItems: "Aucun article n'a encore été ajouté au panier.",
            notAbleToPrepareForCheckout: "Le panier n'a pas pu être préparé pour le paiement.",
            order: "Commander",
            paymentBlockingCart: "Le panier ne peut pas être modifié pendant qu'un paiement est en cours.",
            changingTotalWillRemoveAppliedDiscountsMessage: "Modifier le total supprimera tous les remises appliquées. Tu devras les réappliquer.",
            removeDiscounts: "Supprimer les Remises",
        },
        cartItemsList: {
            cart: "Panier",
        },
        changeAllocationDetailsModal: {
            endUsersCouldNotBeRemoved: "Les utilisateurs finaux n'ont pas pu être supprimés",
            rename: "Renommer",
            removeEndUsers: "Supprimer les utilisateurs finaux",
            resetTable: "Check-Out Des Utilisateurs",
            resetTableText: "Tous les {0} utilisateurs doivent être retirés de {1}? Ceci n'est pas révocable.",
            transferBill: "Transférer",
            transferSelectedBillItems: "Transférer {0} articles",
            print: "Imprimer",
        },
        currency: {
            chf: "CHF",
        },
        discounts: {
            removeSingleItemDiscountPrompt: "Supprimer la remise ?",
            removeAllItemDiscountsPrompt: "Cette remise s'applique à plusieurs articles et ne peut être supprimée que dans son ensemble. Supprimer ?",
        },
        enums: {
            cancellationMode: {
                Amount: "Montant manuel",
                Positions: "Postes individuels",
                WholeOrder: "Commande entière",
            },
            cancellationReason: {
                IncorrectIncompleteItemInformation: "Informations incorrectes ou incomplètes sur l'article",
                OrderedIncorrectlyEndUser: "Commandé de manière incorrecte (utilisateur final)",
                OrderedIncorrectlyStaffMember: "Commandé de manière incorrecte (membre du personnel)",
                EndUserChangedMind: "L'utilisateur final a changé d'avis",
                ItemNotAvailable: "Article non disponible",
                PriceWrong: "Prix erroné",
                BusinessClosedAtFulfilmentTime: "Entreprise fermée au moment de l'exécution",
                LossBreakageStaffMember: "Casse / Perte (membre du personnel)",
                LateFulfilment: "Exécution tardive",
                BadQualityPresentation: "Mauvaise qualité / présentation",
                LossBreakageEndUser: "Casse / Perte (utilisateur final)",
                CustomerDidNotPayWalkout: "Le client n'a pas payé (Délit de fuite)",
                Other: "Autre",
            },
            connectionState: {
                Connected: "Connecté!",
                Connecting: "Connexion en cours...",
                Disconnected: "Déconnecté!",
                Disconnecting: "Déconnexion en cours...",
                Reconnecting: "Reconnexion en cours...",
            },
            fulfillmentTimeMode: {
                DeliveryTime: "Heure de livraison",
                None: "Non",
                PickupTime: "Heure de retrait",
                Time: "Temps (type non spécifié)",
            },
        },
        general: {
            accept: "Accepter",
            add: "Ajouter",
            addingButtonPlaceholder: "...",
            anonymousUser: "Utilisateur final anonyme",
            back: "Retour",
            cancel: "Annuler",
            close: "Fermer",
            continue: "Continuer",
            confirm: "Bestätigen",
            date: "Date",
            display: "Afficher",
            edit: "Modifier",
            end: "Fin",
            error: "Erreur",
            failedLoadingData: "Les données n'ont pas pu être chargées.",
            loading: "En cours de chargement...",
            no: "Non",
            of: "sur",
            ok: "Ok",
            operationFailed: "L'opération n'a pas pu être réalisée.",
            pleaseSelect: "Merci de sélectionner",
            remove: "Effacer",
            reset: "Réinitialiser",
            save: "Sauvegarder",
            start: "Début",
            time: "Heure",
            today: "Aujourd'hui",
            unknown: "Inconnu",
            understood: "Compris",
            yes: "Oui",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Appareil non trouvé. La page va se recharger, veuillez vous connecter à nouveau.",
            unauthorizedPleaseRefresh: "Ta session a expiré. La page va se recharger, merci de réessayer.",
        },
        linkOffer: {
            childLocation: "Site enfant",
            offers: "Offres",
            linkedOffers: "Offres liées",
            linkedOffer: "Offre liée",
            noLinkedOffers: "Aucune offre liée",
            noAvailableOptions: "Aucune option disponible"
        },
        offerSection: {
            loadingData: "Chargement des données...",
            noActiveOffer: "Pas d'offre active",
            noOrderServiceConfigured: "Pas de Service de Commande configuré",
        },
        order: {
            itemsSelected: "{0} article(s) sélectionné(s)",
        },
        orderAndPayView: {
            failedLoadingOffer: "Échec du chargement de l'offre.",
            failedToAllocateToTable: "Check-in échoué",
            failedLoadingBill: "Échec du chargement de la facture",
        },
        openBills: {
            bill: "Note",
            due: "Due",
            failedLoadingBills: "Échec du chargement des factures ouvertes.<br>Veuillez réessayer plus tard.",
            loadingData: "Chargement des données...",
            noOpenBills: "Pas de notes impayées",
            occupancy: "Occupation",
            open: "Ouvert",
            operator: "Opérateur",
            ordersForNow: "Commandes pour : Maintenant",
            ordersForNowOrLater: "Commandes pour : Maintenant ou plus tard",
            room: "Salle",
            since: "Depuis",
            table: "Table",
            title: "Notes impayées",
        },
        pay: {
            approximately: "env.",
            btnOrderAgain: "Commande Supplémentaire",
            cartChangedAndPleaseWaitMessage: "En raison d'un manque de disponibilité ou d'un changement de prix, au moins un article sera bientôt supprimé de ton panier. Merci de patienter quelques secondes pour la mise à jour.",
            cartChangedMessage: "En raison d'un manque de disponibilité ou d'un changement de prix, au moins un article sera supprimé de ton panier.",
            cartChangedTitle: "Nouveau prix total",
            consumption: "Consommation",
            discount: "Remise",
            discountVoucherCode: "Code de remise / de bon",
            enterTip: "Saisir un pourboire (optionnel)",
            failedBillInvalidSelection: "Au moins un des articles sélectionnés a déjà été payé ou annulé. Merci de vérifier ta sélection.",
            failedBillPaymentInProgress: "Un autre paiement est en cours, les articles concernés ont été désélectionnés. Effectue un paiement sans ces articles ou réessaie dans quelques minutes.",
            failedEmailNotConfirmed: 'Merci de t\'inscrire : Cercle en haut à droite > "S\'inscrire" > suivre les instructions. Tu es déjà inscrit ? Cercle en haut à droite > "Profil" > "Renvoyer l’E-Mail de Confirmation" > ouvrir l\'e-mail et confirmer',
            failedIdentityNotSignedUp: "Merci de t'inscrire : Cercle en haut à droite > \"S'inscrire\"",
            failedOutOfStock: "La quantité souhaitée n'est malheureusement pas disponible, merci d'adapter le panier :<br />{0}",
            failedPaymentInProgress: "Un autre paiement est en cours. Merci de patienter",
            failedPaymentInvalidCard: "Malheureusement, cette marque n'est pas acceptée ou la carte a été refusée par ta banque.",
            failedPaymentUnknownReason: "Paiement annulé. Merci de réessayer.",
            fulfillmentSlotTimedOut: "L'heure sélectionnée a expiré. Merci de sélectionner une nouvelle heure.",
            isEmailCorrectQuestion: "Est-ce correct : {0}?",
            newFulfillmentSlotAvailable: "Nouvelle {0} {1} en raison des articles sélectionnés ou d'un dépassement de délai.",
            noActivePaymentService: "Pas de Service de Paiement actif.",
            noFulfillmentSlotAvailable: "Au moins un article sélectionné n'est pas disponible, merci de réessayer plus tard ou de modifier ta sélection.",
            noFulfillmentSlotAvailableV2: "Pas de disponibilité. {0} pourrait ajouter des disponibilités dans le futur, merci de revenir ici prochainement.",
            paymentInProgressWarning: "Attention, autre paiement en cours. Si tu l'as autorisé chez le prestataire de paiement, la commande sera déclenchée sous peu - merci d’Annuler. Si le paiement a échoué ou si tu veux commander davantage, choisis Commande Supplémentaire.",
            paymentRecentlyDoneWarning: 'Attention, double commande potentielle. Tu as récemment commandé avec succès, voir "Commandes" dans le menu latéral (cercle supérieur droit). Passer une commande supplémentaire ?',
            payNow: "Payer",
            pleaseEnterEndUsersEmail: "Veuillez saisir l'adresse e-mail de l'utilisateur final.",
            received: "Reçu",
            scheduledTime: "heure programmée",
            tip: "Pourboire",
            twintReturnWarning: "Merci de retourner au navigateur après le paiement pour accélérer la commande et obtenir des informations importantes.",
            walleePaymentNotAvailable: "Désolé, ce moyen de paiement est temporairement indisponible. Essaye à nouveau ou utilise un autre moyen de paiement.",
        },
        print: {
            failedPrintReceipt: "Travail d'impression échoué",
            orderReceiptPrinted: "Travail d'impression envoyé",
        },
        profile: {
            email: "E-mail",
            emailConfirmed: "Confirmé",
            emailUnconfirmed: "Non confirmé",
        },
        qrScanner: {
            pointCameraQr: "Dirige ton appareil photo en direction du QR code",
            scanQr: "Scanner le QR code",
        },
        receipt: {
            printReceipt: "Imprimer le Reçu",
            failedPrintReceipt: "Travail d'impression échoué",
            noProductionSiteEnabledForRoom: "Aucune imprimante de reçus activée n'est attribuée à cette table / salle.",
            sendReceipt: "Envoyer le Reçu",
            failedSendReceipt: "Le reçu n'a pas pu être envoyée. Merci de réessayer.",
            sentReceiptTo: "Le reçu a été envoyé à {0}.",
        },
        renameBillModal: {
            billNameLabel: "Nom de la note",
            billNamePlaceholder: "Nouveau nom de la note...",
        },
        report: {
            paymentMethodsReport: "Rapport sur les moyens de paiement",
        },
        roomPlan: {
            failedLoadingTables: "Les tables n'ont pas pu être chargées.<br />Veuillez réessayer plus tard.",
            loadingTables: "Chargement des tables...",
            room: "Salle",
            selectTableToTransferBill: "Sélectionner la destination",
        },
        tableAllocationContextMenu: {
            adjustEndUsersCountFailed: "Le nombre d’utilisateurs finaux n’a pas pu être ajusté.",
        },
    };
};

const setItalian = () => {
    translations = {
        addToCartPopover: {
            price: "Prix",
            optional: "Opzionale",
            optionSing: "opzione",
            optionPlur: "opzioni",
            chooseExact: "Seleziona {0} {1}",
            chooseMin: "Seleziona almeno {0} {1}",
            chooseUpTo: "Opzionale. Seleziona fino a {0} {1}",
            chooseBetween: "Seleziona {0} - {1} opzioni",
            upToTotalItems: "In totale fino a {0} articoli",
            chooseOption: "Seleziona le tue opzioni",
            loadingOptions: "Le opzioni sono caricate...",
            failedLoadingOptions: "Le opzioni non possono essere caricate.",
            adding: "...",
        },
        allocation: {
            allocationFailed: "Purtroppo, il check-in non è riuscito. Si prega di ricaricare la pagina e riprovare.",
        },
        auth: {
            sessionExpiredTitle: "Sessione scaduta",
            sessionExpiredMessage: "La sua sessione è scaduta. Effettuare nuovamente il login.",
            sessionExpiredBecauseAccessRightsChangedMessage: "Siete stati disconnessi a causa di una modifica dei diritti di accesso. Si prega di effettuare nuovamente il login.",
        },
        bill: {
            clearSelection: "Annullare la selezione",
            exclTip: "escl. mancia",
            fullyPaidItems: "Articoli Completamente Pagati",
            noOrderYet: "Tutto è pagato, grazie!",
            paid: "Pagato",
            selectAll: "Selezionare tutto",
        },
        billSection: {
            loadingData: "Caricamento dati...",
            noPaymentServiceConfigured: "Nessun Servizio di Pagamento configurato",
            processingPaymentDevicePayment: "Pagamento in corso...",
        },
        cancellation: {
            amount: "Importo",
            cancellation: "Annullamento",
            cancellationFailed: "Non è stato possibile annullare l'ordine.",
            cancellationNotAllowedForPayment: "L'annullamento non è consentito per questo pagamento.",
            canStockBeReused: "Lo stock può essere riutilizzato?",
            cancellationSuccessful: "Cancellazione riuscita",
            confirmMessage: "{{amt}} CHF si annullano davvero? Questo non può essere invertito.",
            confirmTitle: "Effettuare la cancellazione?",
            failedLoading: "L'ordine non può essere caricato.",
            loading: "L'ordine è in fase di caricamento...",
            notNow: "Non adesso",
            notPaid: "Non pagato",
            offlineMode: "Rimborso offline",
            paid: "Pagato",
            payment: "Pagamento",
            paymentMethod: "Mezzo di pagamento",
            positionSectionTitle: "Quali unità di <b>{{itemName}}</b> devono essere cancellate?",
            positionsText: "Selezionare le voci da cancellare:",
            reason: "Motivo",
            quantity: "Quantità",
            status: "Stato",
            submitBtn: "Si, annullare",
            title: "Annullamento",
            totalIncTip: "Totale (mancia inclusa)",
            user: "Utente",
            wholeOrderText: "L'intero ordine verrà annullato.",
            singleCancellationFailed: "La cancellazione è fallita. Si prega di riprovare.",
            multipleCancellationsFailed: "Almeno una cancellazione è fallita. Alcuni pagamenti potrebbero non essere stati rimborsati. Si prega di riprovare.",
            multiplePdPaymentCancellationsNotSupported: "Questa cancellazione include più pagamenti via un dispositivo di pagamento. Si prega di limitarla a un massimo di un pagamento via dispositivo di pagamento.",
            twintOnlineRefundNotSupported: "I pagamenti Twint effettuati su dispositivi di pagamento non possono essere rimborsati.",
            wholeOrderDesc: "L'intero ordine verrà annullato.",
        },
        cancellationReason: {
            reason: "Motivo",
        },
        cart: {
            addComment: "Aggiungere richieste speciali",
            failedToAdd: "L'articolo non può essere aggiunto.",
            failedToChange: "L'articolo non può essere modificato.",
            failedToRemove: "L'articolo non può essere rimosso.",
            haveItemsInCart: "Hai articoli nel tuo carrello di {0}. Se continui, il tuo carrello verrà cancellato.",
            noItems: "Nessun articolo è stato ancora aggiunto al carrello.",
            notAbleToPrepareForCheckout: "Il carrello non poteva essere preparato per il pagamento.",
            order: "Ordinare",
            paymentBlockingCart: "Il carrello non può essere modificato mentre un pagamento è in corso.",
            changingTotalWillRemoveAppliedDiscountsMessage: "Modificare il totale rimuoverà tutti gli sconti applicati. Dovrai riapplicarli.",
            removeDiscounts: "Rimuovi Sconti",
        },
        cartItemsList: {
            cart: "Carrello",
        },
        changeAllocationDetailsModal: {
            endUsersCouldNotBeRemoved: "Non è stato possibile rimuovere gli utenti finali",
            rename: "Rinominare",
            removeEndUsers: "Rimuovere gli utenti finali",
            resetTable: "Checkout l'Utente",
            resetTableText: "Tutti i {0} utenti devono essere rimossi dal {1}? Questo non è revocabile.",
            transferBill: "Trasferire",
            transferSelectedBillItems: "Trasferire {0} articoli",
            print: "Stampare",
        },
        currency: {
            chf: "CHF",
        },
        discounts: {
            removeSingleItemDiscountPrompt: "Rimuovere lo sconto?",
            removeAllItemDiscountsPrompt: "Questo sconto si applica a più articoli e può essere rimosso solo nel suo complesso. Rimuovere?",
        },
        enums: {
            cancellationMode: {
                Amount: "Importo manuale",
                Positions: "Singole voci",
                WholeOrder: "Ordine intero",
            },
            cancellationReason: {
                IncorrectIncompleteItemInformation: "Informazioni errate / incomplete sull'articolo",
                OrderedIncorrectlyEndUser: "Ordinato in modo errato (utente finale)",
                OrderedIncorrectlyStaffMember: "Ordinato in modo errato (membro del personale)",
                EndUserChangedMind: "L'utente finale ha cambiato idea",
                ItemNotAvailable: "Articolo non disponibile",
                PriceWrong: "Prezzo sbagliato",
                BusinessClosedAtFulfilmentTime: "Attività chiusa al momento dell'adempimento",
                LossBreakageStaffMember: "Rottura / Perdita (membro del personale)",
                LateFulfilment: "Adempimento tardivo",
                BadQualityPresentation: "Pessima qualità / presentazione",
                LossBreakageEndUser: "Rottura / Perdita (utente finale)",
                CustomerDidNotPayWalkout: "Il cliente non ha pagato (Fuga)",
                Other: "Altro",
            },
            connectionState: {
                Connected: "Connesso!",
                Connecting: "La connessione è stabilita...",
                Disconnected: "Connessione terminata!",
                Disconnecting: "La connessione è terminata....",
                Reconnecting: "La connessione è stabilita...",
            },
            fulfillmentTimeMode: {
                DeliveryTime: "Orario di consegna",
                None: "No",
                PickupTime: "Orario di ritiro",
                Time: "Tempo (tipo non specificato)",
            },
        },
        general: {
            accept: "Accettare",
            add: "Aggiungere",
            addingButtonPlaceholder: "...",
            anonymousUser: "Utente finale anonimo",
            back: "Ritorno",
            cancel: "Cancellare",
            close: "Chiudere",
            continue: "Continuare",
            confirm: "Confirmer",
            date: "Data",
            display: "Mostrare",
            edit: "Modificare",
            end: "Fine",
            error: "Errore",
            failedLoadingData: "I dati non possono essere caricati.",
            loading: "Caricamento...",
            no: "No",
            of: "su",
            ok: "Ok",
            operationFailed: "L'operazione non può essere eseguita.",
            pleaseSelect: "Si prega di selezionare",
            remove: "Eliminare",
            save: "Salvare",
            start: "Inizio",
            reset: "Reset",
            time: "Ora",
            today: "Oggi",
            unknown: "Sconosciuto",
            understood: "Capito",
            yes: "Sì",
        },
        messages: {
            deviceNotFoundPleaseRefresh: "Dispositivo non trovato. La pagina verrà ricaricata, si prega di accedere nuovamente.",
            unauthorizedPleaseRefresh: "La tua sessione è finita. La pagina si ricaricherà, si prega di riprovare.",
        },
        linkOffer: {
            childLocation: "Ubicazione subordinata",
            offers: "Offerte",
            linkedOffers: "Offerte collegate",
            linkedOffer: "Offerta collegata",
            noLinkedOffers: "Nessuna offerta collegata",
            noAvailableOptions: "Nessuna opzione disponibile"
        },
        offerSection: {
            loadingData: "Caricamento dati...",
            noActiveOffer: "Nessuna offerta attiva",
            noOrderServiceConfigured: "Nessun Servizio d'Ordine configurato",
        },
        order: {
            itemsSelected: "{0} articolo/i selezionato/i",
        },
        orderAndPayView: {
            failedLoadingOffer: "Impossibile caricare l'offerta.",
            failedToAllocateToTable: "Check-in fallito",
            failedLoadingBill: "Impossibile caricare la fattura",
        },
        openBills: {
            bill: "Conto",
            due: "Dovuto",
            failedLoadingBills: "Impossibile caricare le fatture aperte.<br>Si prega di riprovare più tardi.",
            loadingData: "Caricamento dati...",
            noOpenBills: "Nessun conti aperti",
            occupancy: "Occupazione",
            open: "Aperto",
            operator: "Operatore",
            ordersForNow: "Ordini per: Ora",
            ordersForNowOrLater: "Ordini per: Ora o più tardi",
            room: "Sala",
            since: "Da",
            table: "Tavolo",
            title: "Conti aperti",
        },
        pay: {
            approximately: "ca.",
            btnOrderAgain: "Ordinare In Aggiunta",
            cartChangedAndPleaseWaitMessage: "A causa della mancanza di disponibilità o di una modifica del prezzo, almeno un articolo verrà eliminato a breve dal carrello. Attendere qualche secondo per l'aggiornamento.",
            cartChangedMessage: "A causa della mancanza di disponibilità o di una modifica del prezzo, almeno un articolo verrà eliminato dal carrello.",
            cartChangedTitle: "Nuovo prezzo totale",
            consumption: "Consumo",
            discount: "Rabais",
            discountVoucherCode: "Codice sconto / voucher",
            enterTip: "Inserire una mancia (opzionale)",
            failedBillInvalidSelection: "Almeno un articolo selezionato è già stato pagato o annullato. Si prega di controllare la selezione.",
            failedBillPaymentInProgress: "È in corso un altro pagamento, le articoli interessati sono stati deselezionati. Effettua un pagamento senza questi articoli o riprova tra qualche minuto.",
            failedEmailNotConfirmed: 'Si prega di registrarsi: Cerchio in alto a destra > "Registrare" > seguire le istruzioni. Già registrato? Cerchio in alto a destra > "Profilo" > "Inviare Nuovamente l’E-mail di Conferma" > aprire e confermare l\'e-mail',
            failedIdentityNotSignedUp: 'Si prega di registrarsi: Cerchio in alto a destra > "Registrare"',
            failedOutOfStock: "La quantità desiderata non è purtroppo disponibile, si prega di regolare il carrello:<br />{0}",
            failedPaymentInProgress: "Un altro pagamento è in corso. Si prega di attendere",
            failedPaymentInvalidCard: "Purtroppo questa marca non è accettata o la carta è stata rifiutata dalla tua banca.",
            failedPaymentUnknownReason: "Pagamento annullato. Si prega di riprovare.",
            fulfillmentSlotTimedOut: "L'orario selezionato è scaduto. Si prega di selezionare un nuovo orario.",
            isEmailCorrectQuestion: "È corretto: {0}",
            newFulfillmentSlotAvailable: "Nuovo {0} {1} a causa degli articoli selezionati o del timeout.",
            noActivePaymentService: "Nessun Servizio di Pagamento attivo.",
            noFulfillmentSlotAvailable: "Almeno un articolo selezionato non è disponibile, riprovare più tardi o modificare la selezione.",
            noFulfillmentSlotAvailableV2: "Nessuna disponibilità. {0} potrebbe aggiungere disponibilità in futuro, si prega di controllare qui presto.",
            paymentInProgressWarning: "Attenzione, altro pagamento in corso. Se l'hai già autorizzato con il fornitore di pagamenti, l'ordine verrà attivato a breve - si prega di annullare. Se il pagamento non è andato a buon fine o se si desidera ordinare di più, selezionare Ordinare In Aggiunta.",
            paymentRecentlyDoneWarning: 'Attenzione, potenziale doppio ordine. Hai recentemente ordinato con successo, vedi "Ordini" nel menu laterale (cerchio in alto a destra). Vuoi fare un altro ordine?',
            payNow: "Pagare",
            pleaseEnterEndUsersEmail: "Si prega di inserire l'indirizzo email dell'utente finale.",
            received: "Ricevuto",
            scheduledTime: "orario programmato",
            tip: "Mancia",
            twintReturnWarning: "Si prega di tornare al browser dopo il pagamento per accelerare l'ordine e ricevere informazioni importanti.",
            walleePaymentNotAvailable: "Spiacente, questo metodo di pagamento non è temporaneamente disponibile. Riprovare o provare un altro metodo di pagamento.",
        },
        print: {
            orderReceiptPrinted: "Lavoro di stampa inviato",
            failedPrintReceipt: "Lavoro di stampa fallito",
        },
        profile: {
            email: "E-Mail",
            emailConfirmed: "Confermato",
            emailUnconfirmed: "Non confermato",
        },
        qrScanner: {
            pointCameraQr: "Dirige il tuo dispositivo fotografico verso il QR code",
            scanQr: "Scanner il QR code",
        },
        receipt: {
            failedPrintReceipt: "Lavoro di stampa fallito",
            failedSendReceipt: "Non è stato possibile inviare la ricevuta. Si prega di riprovare.",
            noProductionSiteEnabledForRoom: "A questo tavolo / stanza non è assegnata alcuna stampante per ricevute attiva.",
            printReceipt: "Stampare la Ricevuta",
            sendReceipt: "Inviare La Ricevuta",
            sentReceiptTo: "La ricevuta è stata inviata a {0}.",
        },
        renameBillModal: {
            billNameLabel: "Nome del conto",
            billNamePlaceholder: "Nuovo nome del conto...",
        },
        report: {
            paymentMethodsReport: "Rapporto sui mezzi di pagamento",
        },
        roomPlan: {
            failedLoadingTables: "Non è stato possibile caricare le tavole.<br />Si prega di riprovare più tardi.",
            loadingTables: "Caricando le tavole...",
            room: "Sala",
            selectTableToTransferBill: "Selezionare la destinazione",
        },
        tableAllocationContextMenu: {
            adjustEndUsersCountFailed: "Impossibile modificare il numero di utenti finali.",
        },
    };
};

setSharedTranslationsLanguage(clientLanguage());

export function setSharedTranslationsLanguage(language: Language) {
    switch (language) {
        case Language.English:
            setEnglish();
            break;
        case Language.German:
            setGerman();
            break;
        case Language.French:
            setFrench();
            break;
        case Language.Italian:
            setItalian();
            break;
        default:
            setEnglish();
            break;
    }
}
